/**
 * Returns parent element until parent element with special selector
 * @param {Object} element
 * @param {String} selector
 * @return {Object|Null}
 */
function parentUntil(element, selector) {
  // early return
  if (!element || !selector) return null;
  if (element.tagName === 'BODY') return null;

  switch (true) {
    case selector.includes('.'): {
      const className = selector.substring(1);

      if (element.parentNode && element.parentNode.classList.contains(className)) return element.parentNode;

      break;
    }
    case selector.includes('#'): {
      const ID = selector.substring(1);

      if (element.parentNode && element.parentNode.id === ID) return element.parentNode;

      break;
    }
    case selector.includes('[') && selector.includes(']'): {
      const attribute = selector.substring(1).slice(0, -1);

      if (element.parentNode && element.parentNode.hasAttribute(attribute)) return element.parentNode;

      break;
    }
    default: {
      if (element.parentNode && element.parentNode.tagName.toUpperCase() === selector.toUpperCase()) return element.parentNode;

      break;
    }
  }

  return parentUntil(element.parentNode, selector);
};

export default parentUntil;
